/**
 * ╔════════════════════════════════════════════════════════════╗
 * ║  EXECUTION CORE PHILOSOPHY                                 ║
 * ╠════════════════════════════════════════════════════════════╣
 * ║  Core Philosophy of Execution: Executing Plans with Precision       ║
 * ╚════════════════════════════════════════════════════════════╝
 */

export const EXECUTION_CORE = `
# Execution Phase Philosophy

Execute with precision and quality:
1. Follow the plan systematically
2. Handle errors gracefully
3. Provide clear progress updates
4. Maintain code quality standards

Execution transforms plans into reality.
`;
